import { useEffect } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useConfig, useServices, useUrlLocation } from 'core/common/hooks';
import { redirectToUrl } from 'core/common/utils/redirectToUrl';

export const SubscriptionTerms = () => {
  const config = useConfig();
  const { analyticsService } = useServices();
  const { previousLocation } = useUrlLocation();

  useEffect(() => {
    analyticsService.techPageOpened(BASE_ROUTES.TECH_SUBSCRIPTION_TERMS, previousLocation);
    redirectToUrl(config.techLinks.terms);
  }, [config.techLinks.terms, analyticsService, previousLocation]);

  return null;
};
